import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import axios from "../../axios"
import  { useHistory } from  'react-router-dom'
import { isEmpty } from "lodash";
import "bootstrap/dist/css/bootstrap.min.css";
import TableContainer from "../../components/Common/TableContainer";
import * as Yup from "yup";
import { useFormik } from "formik";
import { makeStyles } from '@material-ui/core/styles';
import  Spinner  from 'react-spinkit'
import Backdrop from '@material-ui/core/Backdrop';
import DeleteModal from "../../components/Common/DeleteModal"
import '../../NumberInput.css'
import moment from 'moment'
import numeral from "numeral";
import SweetAlert from "react-bootstrap-sweetalert";
import { saveAs } from 'file-saver';
import { Document, Page } from 'react-pdf';
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },



}));
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";


//redux
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,Card,CardBody,
  FormFeedback,
  Label,
  Container
} from "reactstrap";

import { Dialog, DialogTitle } from "@material-ui/core";
function DatatableTables() {
  const history = useHistory()
  const [allcartproducts, setallcartproducts] = useState([])
  const [purchseid, setpurchseid] = useState('')
  const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
  const [Purchasesavess, setPurchasesavess] = useState(false)
  const [allsupplierinfo, setallsupplierinfo] = useState([])
  const [allproductslists, setallproductslists] = useState([])
  const [qtyval, setqtyval] = useState('1')
  const classes = useStyles();
  const [pricevalue, setpricevalue] = useState('')
  const [modal, setModal] = useState(false)
  const [indexalueofupdate, setindexalueofupdate] = useState('')
  const [Productonecollect, setProductonecollect] = useState([])
  const [sgstper, setsgstper] = useState('')
  const [salesrate, setsalesrate] = useState('')
  const [allsupplierid, setallsupplierid] = useState(1)
  const [proid, setproid] = useState('')
  const [vatper, setvatper] = useState('')
  const [uomdesc, setuomdesc] = useState('')
  const [cgstper, setcgstper] = useState('')
  const [taxid, settaxid] = useState('')
  const [purchaseqtys, setpurchaseqtys] = useState('1')
  const [totalqty, settotalqty] = useState('')
  const [TOtaligstamt, setTOtaligstamt] = useState('')
  const [deleteModal, setDeleteModal] = useState(false)
  const [deletid, setdeletid] = useState('')
  const [delteprods, setdelteprods] = useState(false)
  const [updatenetamt, setupdatenetamt] = useState('')
  
  const [productnames, setproductnames] = useState('')
  const [provalue, setprovalue] = useState([])
  const [uomid, setuomid] = useState('')
  const [conqty, setconqty] = useState('')
  const [discountper, setdiscountper] = useState('')
  const [gstper, setgstper] = useState('')
  const [sgstid, setsgstid] = useState('')
  const [dailoa1, setdailoa1] = useState(false)
  const [igstper, setigstper] = useState('')
  const [produpdata, setprodupdata] = useState(false)
  var imageDefault = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAANlBMVEX///+/v7+8vLzKysr8/Pzg4ODFxcXb29vT09Pj4+P4+PjBwcH6+vry8vLY2NjIyMjs7Ozo6Oia8u11AAAEdUlEQVR4nO2d65bqIAxGp/Smrb34/i971KqlEC7FGuJZ3/7dKewJBgK4/PsDAAAAAAAAAAAAAAAA4KUam5+i3m94UsUPoVoYwlA6MIShfGAIQ/nAEIbyOcBQSeNww9NZGOXBhuq8+w1fxugfDG1gmB0YBoFhdmAYBIbZgWEQGGYHhkFgmB0YBoFhdmAYBIbZyWB4qVI6mgyv4WUeH7u007lL7vFeWA3n8rUFrZqWK5KchnWvPapOTGFkNDQPOJrhk45Hw2d4Ns+oVPlRz2NhMxyawkTtv2OWAJvhSBwzfjBO2+g/5TLs7BDeSF4eDP0Y+yiX4UydFKtT4pRxa3SKTcVchtQgLYrobhq0Kj7+XIb0aX+fZtipHfH/ScPlZZG5Jq9hk2RYP96lTnFPcxnWpGF52d2eNrPGPc5lOJC5NDrl65Sv1fs16nEuw8v20sdCP+9uTh8NZVSuYVvTnKlBmjAdaqu/uH8Qm2FVWuNUJYSwOu3tLV9tcelNw5SF9yZjRaVixvpwbrZRTKnyuyKysRXOGn/QBqpK25QzptVm9598eyfqXDaPnah+GlNmwr/aGOcqYl3DvJtYzXU7jvU1bbVmVdExE+pP7Qjb6TiiOBFmOPuyD7XyC+djWYadGt2KxE5PzMpWluHtXc6KQZ/rNYK5RpThfWXnrGzp6iRcQ0ky7KbHK+iBup3rtQZD6wZJhq+9HDIsri89BBsUZPguIal0Y871K6ECRY6hXkFaimQeXQjVUHIMNwWkuVax5/q1xcC6Rozh0G+7vYmidaqzCaJ/whBjaEZJr608Y7QIHvBIMbR3/dfB55jr3/hrKCGGxMHN+vmi53rtSW+uEWLYUj1/dsY1169tetc1MgwHaw9HU3TN9Svec0huw4os6CZHcO7dcc/163O+XMNteC0JRfdk0Aby6BNfDcW9i1EquzedI4R36vAYLfy5htnwtnBRvaHo/SZxjN8Nz7UO5ltf97WnMgbqHCfhRbmHKa/hdXl2qxjzQQsaunMNr+FzUlD62W8bORD9TM4gshpe3xVg+Z7BonJlmN55mMhpWGkV4GughtacsbgvLnAa6hXga6B666I9OGsoRsPtMbCa7l2q6OVaAs6uMxpejXDdd+SPSTMP+vyGdri6+bAQui8u8BmaIbwxUdcXkg0dNRTjOf6BNiSOGirrXYxjcXQ+632ag6EPE7kMiU/h4dA1FJfhgUnTzZTRkCOEt8apYcpj+P1E6u4+j+H3E+kCdUmKxZAjkS4QrbMY8nwKC7qGYjFkSaQL9rqGw5AthORhIoMhUyJ9ksPwsDI+Brv97xtWY8mJNUwZYtixYu0qyjhd+yYwDALD7MAwCAyzA8MgMMwODIPAMDtHGxZ1JYvjDRvWajCC7SYRfhsBhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvJJM/wpEgyv9U+R8iNaAAAAAAAAAAAAAAAAAP4r/gEYCYE2Xwz6DQAAAABJRU5ErkJggg=='
  const [prodimage, setprodimage] = useState('')
  const [fromdate, setfromdate] = useState(new Date());
  const [todate, settodate] = useState(new Date());
  const [Delteid, setDelteid] = useState('');
  const [allpurchaseorderlists, setallpurchaseorderlists] = useState([])
  const [purchsedeltemessage, setpurchsedeltemessage] = useState(false)
  const [billraised, setbillraised] = useState('')
  const [purchsebillrasied, setpurchsebillrasied] = useState(false)
  const [purchasebilledit, setpurchasebilledit] = useState(false)
  const [purchasegetone, setpurchasegetone] = useState([])
  const [suppliid, setsuppliid] = useState(0)
  const [open1, setopen1] = useState(false)
  const [allpurchasenetamout, setallpurchasenetamout] = useState('')
  useEffect(() => {
    Getallproductslistsss()
      //////////////////console.log(localStorage.getItem('Carts'))
    //  let cartproducts = []
      //let productofcart = JSON.parse(localStorage.getItem('Carts'))
      //cartproducts.push()
  //setallcartproducts(productofcart)
  var date =  new Date()
  var enquirydates = new Date()
  var receiveddatesaa = new Date()
  var deliverydtate = new Date()
  var firstday =  new Date(date.getFullYear(), date.getMonth(),1)
  // var lastday =  new Date(date.getFullYear(), date.getMonth()+1,0)
  var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
  setfromdate(moment(firstday).format('YYYY-MM-DD'))
  settodate(moment(lastday).format('YYYY-MM-DD'))
  GETallpurhase()
  Getallsuppliervalue1()
      }, [])
      
      const Getallsuppliervalue1 = async() => {
        const get= await axios.instance.get('/Getallsupplier',{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
        
        }}).then((res) => {
          
          const data  =res.data
          const options = data.map(b => ( {
          'label' : b.Customer_Name,
          'value' : b.Customer_Id
          }))
          options.push({'label' : 'All' , 'value' : '0'})
    setallsupplierinfo(options)
    //////////console.log(data)
    
        })
        }
      const Getallproductslistsss = async() => {
        const get= await axios.instance.get('/Getallproducts',{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
        
        }}).then((res) => {
          
  
  
    setallproductslists(res.data)

        })
        }
  
  
  
        const GETallpurhase =  async() => {
          var date =  new Date()
         
          var firstday =  new Date(date.getFullYear(), date.getMonth(),1)
          //////////////////console.log(moment(firstday).format)
          // var lastday =  new Date(date.getFullYear(), date.getMonth()+1,0)
          var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
          const Getholi =  await axios.instance.get(`/Getallpurchasehdr/${localStorage.getItem('CompanyId')}/${allsupplierid}/${suppliid}/${moment(firstday).format('YYYYMMDD')}/${moment(lastday).format('YYYYMMDD')}` , {
            
          
         
          
          
           headers: {'Authorization':tokent,
          'Content-Type': 'application/json',
          
          }}).then((Res) => {
        setallpurchaseorderlists(Res.data)
       setpurchsebillrasied(false)
      for(const data of Res.data) {
        setbillraised(data.Billed)
      //////////////console.log(data.Billed)
      }
      let  totalnetamount = []
      for(const data of Res.data) {
        totalnetamount.push(data.Net_Amount)
      }
      var totalsalescount = 0
      for(let i =0; i< totalnetamount.length; i++) {
        totalsalescount += totalnetamount[i]
      }
      setallpurchasenetamout(totalsalescount)
      
        ////////////////console.log(Res.data,'purcha')
          })
        }
        const Getfromdateset = async(value) => {
         // if(parseInt(moment(new Date('01 January 0 00:00:00 ')).format('YYYY')) <  parseInt(moment(new Date(value)).format('YYYY') )) {
  
          
          setfromdate(value)
          const Getenquiry = await axios.instance.get(`/Getallpurchasehdr/${localStorage.getItem('CompanyId')}/${allsupplierid}/${suppliid}/${moment(value).format('YYYYMMDD')}/${moment(todate).format('YYYYMMDD')}`, 
        
            { headers: {'Authorization':tokent,
          'Content-Type': 'application/json'}}).then((res) => {
              setallpurchaseorderlists(res.data)
              let  totalnetamount = []
              for(const data of res.data) {
                totalnetamount.push(data.Net_Amount)
              }
              var totalsalescount = 0
              for(let i =0; i< totalnetamount.length; i++) {
                totalsalescount += totalnetamount[i]
              }
              setallpurchasenetamout(totalsalescount)
          })
          
       // }
        }
        
        
        const GetTOdateset = async(value) => {
          //if(parseInt(moment(new Date('01 January 0 00:00:00 ')).format('YYYY')) <  parseInt(moment(new Date(value)).format('YYYY') )) {
        
           
          settodate(value)
          const Getenquiry = await axios.instance.get(`/Getallpurchasehdr/${localStorage.getItem('CompanyId')}/${allsupplierid}/${suppliid}/${moment(fromdate).format('YYYYMMDD')}/${moment(value).format('YYYYMMDD')}`, 
          
         
          
           { headers: {'Authorization':tokent,
          'Content-Type': 'application/json'}}).then((res) => {
              setallpurchaseorderlists(res.data)
              let  totalnetamount = []
              for(const data of res.data) {
                totalnetamount.push(data.Net_Amount)
              }
              var totalsalescount = 0
              for(let i =0; i< totalnetamount.length; i++) {
                totalsalescount += totalnetamount[i]
              }
              setallpurchasenetamout(totalsalescount)
          })
         
        //}
        }
     const Closepopup1 = () => {
setopen1(false)
setdailoa1(false)
     }   
    
      
  const checkoutss = () => {
    setdailoa1(true)
  setTimeout(() => {
    history.push('/Purchase-OrderCheckout')
    setdailoa1(false)
  }, 3000);
  }
  const onClickDelete = user => {
    //////////////console.log(user)
    setdeletid(user.PO_Id)
    setDeleteModal(true)
  }
  
  
  
  const handleCustomerClicks = () => {
    //setCustomerList("");
   // setIsEdit(false);
   //handleUserClick()
   // toggle();
  };
  
  
  
  const toggle = () => {
    if (modal) {
      setModal(false)
     // setUser(null)
    
    } else {
      setModal(true)
    }
  }
  
  const handleUserClick = (arg,index) => {
    //////////////console.log(arg)
   setpricevalue(arg.Rate)
  Updateget(arg.Product_Details_Id,index)
    //setIsEdit(true)
  
    toggle()
  }
  const Deletepurchaseorder = async(id) => {
    //////////////console.log('testdetel',deletid)
    const createHoliday =  await axios.instance.delete(`/deletepurchasorder/${id}`, { headers: {'Authorization':tokent,
    'Content-Type': 'application/json'}}).then((Res) => {
     

      //////////////console.log(Res.data)
     // Getbuyerorders()
       setDeleteModal(false)
       setdailoa1(true)
       GETallpurhase()
       setTimeout(() => {
         setdailoa1(false)
         setdelteprods(true)
  
       }, 2000);
     
      
    })
  }
  const toggledeletemodal  = (id) => {
    setDeleteModal(true)
    setdeletid(id)
    GETallpurhase()
  // setpurchsedeltemessage(true)
  }
  
  const editpage = (id) =>{
history.push(`/Purchase-ordercart/${id}`)
localStorage.setItem('purchseeditid',id)
localStorage.setItem('Purchaseorderedit',true)
localStorage.setItem('purchaseviewscreen','N')
  }
  const Getallsuppliervalue = async(id) => {
    const get= await axios.instance.get(`/Getonepurchasedtl/${id}`,{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      
    //////////////console.log(res.data)
      setpurchasegetone(res.data)
      var getoneprodctsofpurchse = res.data
     //////////console.log('',getoneprodctsofpurchse)
      localStorage.setItem('Carts',JSON.stringify(getoneprodctsofpurchse))
      for (const data of res.data) {
        setbillraised(data.Billed)
      }
      ////////////console.log(res.data)
      let qtytotal = []
    
      for(const data of res.data){
      qtytotal.push(parseFloat(data.Order_Quantity))
      }
      var qtyvalue = 0 
      for (let i = 0; i < qtytotal.length; i++) {
        qtyvalue += qtytotal[i];
      }
      settotalqty(qtyvalue)
      localStorage.setItem('TotalQty',qtyvalue)
      
      let taxtotal = []
      for(const data of res.data) {
      taxtotal.push(parseFloat(data.GSTPer))  
      }
      var taxvalue = 0
      for(let i =0; i< taxtotal.length; i++) {
      taxvalue += taxtotal[i]
      }
      localStorage.setItem('taxvalue',taxvalue)
      //AsyncStorage.setItem('Toataltax', taxvalue.toString())
      let  totalnetamount = []
      for(const data of res.data) {
        totalnetamount.push(parseFloat(data.Rate * data.Order_Quantity))
      }
      var totalnetcount = 0
      for(let i =0; i< totalnetamount.length; i++) {
        totalnetcount += totalnetamount[i]
      }
      //settotalamt(totalnetcount)
      //AsyncStorage.setItem('Totalamt', totalnetcount.toString())
      //localStorage.setItem('Totalsumamounts',totalnetcount)
      
      
      localStorage.setItem('Totalsumamounts',totalnetcount)
     
      let totalIgstamt = []
      for(const data of res.data) {
      totalIgstamt.push(parseFloat((data.Rate * data.Order_Quantity) * data.GSTPer/100))
      ////////////////console.log('igst', data.IGSTPer)
      }
      var  totalIgstvalu = 0
      for(let i=0; i< totalIgstamt.length; i++) {
      totalIgstvalu +=totalIgstamt[i]
      }
      localStorage.setItem('Totaligstvalue',totalIgstvalu)
    
      ////////////////console.log(totalIgstvalu)
      //settotaltax(totalcgstvalu +totalcgstvalu)
      setTOtaligstamt(totalIgstvalu)
    })
    }

  const viewpage = async(id) =>{
    setdailoa1(true)
    history.push(`/Purchaseview/${id}`)
    // localStorage.setItem('purchseeditid',id)
    // const PrintInvoice = await axios.instance.get(`/Purchaseprint/${id}`).then(async() => {
    // const downloadprogress =  await axios.instance.get('/Getpurchaseorder',{ responseType: 'blob'}).then((res) => {
    //   const pdfBlob = new Blob([res.data] ,{type: 'application/pdf'})
      
   // localStorage.setItem('Purchaseorderedit',false)
    //localStorage.setItem('purchaseviewscreen','Y')
    //toggle()
    //history.push(axios.baseURL+`Getpurchaseorder`)
    Getallsuppliervalue(id)
   setopen1(true)

   setTimeout(() => {
    setdailoa1(false)
   }, 2000);
//   })
// })
      }
  const PrintDownload =async(id,id1) => {
    // --const Arg = id.InvoiceId
   setdailoa1(true)
  //////////////console.log('pritn',id)
  
  const PrintInvoice = await axios.instance.get(`/Purchaseprint/${id}`).then(async() => {
  const downloadprogress =  await axios.instance.get('/Getpurchaseorder',{ responseType: 'blob'}).then((res) => {
  const pdfBlob = new Blob([res.data] ,{type: 'application/pdf'})
  const filedata= saveAs(pdfBlob , `Purchaseorder-${id1}.pdf`)
  })
  })
   setTimeout(() => {
   setdailoa1(false) 
   }, 4000);  
  
  }
  const getbuyers =async(id) => {
   
    if(id ==='0'){
      setsuppliid(id)
      setallsupplierid('1')
    }else{
      setsuppliid(id)
      setallsupplierid('0')
  }
  const Getholi =  await axios.instance.get(`/Getallpurchasehdr/${localStorage.getItem('CompanyId')}/${id === '0' ? 1: 0}/${id === '0' ? 0:id}/${moment(fromdate).format('YYYYMMDD')}/${moment(todate).format('YYYYMMDD')}` , {
            
          
         
          
          
    headers: {'Authorization':tokent,
   'Content-Type': 'application/json',
   
   }}).then((Res) => {
 setallpurchaseorderlists(Res.data)
setpurchsebillrasied(false)
for(const data of Res.data) {
 setbillraised(data.Billed)
//////////////console.log(data.Billed)
}
let  totalnetamount = []
for(const data of Res.data) {
  totalnetamount.push(data.Net_Amount)
}
var totalsalescount = 0
for(let i =0; i< totalnetamount.length; i++) {
  totalsalescount += totalnetamount[i]
}
setallpurchasenetamout(totalsalescount)

 ////////////////console.log(Res.data,'purcha')
   })
  
  }
  
  const  billrasid = () => {
    setpurchsebillrasied(true)
  }
  const billrasidedit = () => {
    setpurchasebilledit(true)
  }
  const columns = useMemo(
    () => [
    
      {
        Header: "Po No",

        accessor:"PO_No",
        // cellProps => (
          //<React.Fragment>
           //<b style={{alignItems:"center"}}>{(cellProps.PO_No)}</b>
          //</React.Fragment>
      //),
        disableFilters:true,
        filterable:false
      },
  
      {
        Header: "Po Date",
      
         accessor: "PO_Date",
        // => (
        //   <React.Fragment>
        //    <b>{moment(cellProps.PO_Date).format("DD-MM-YYYY")}</b>
        //   </React.Fragment>
        // ),
        filterable: false,
        disableFilters:true,
       
      },
      {
        Header: "Supplier",
        accessor: "CustomerName",
        filterable: false,
        disableFilters:true,
      
      },
      {
        Header: "Amount",
        accessor: cellProps => (
          <React.Fragment>
           <b style={{alignItems:"center"}}>₹{numeral(cellProps.Net_Amount).format('0,0.00')}</b>
          </React.Fragment>
        ),
        filterable: false,
        disableFilters:true,
      },
      {
        Header: "Delivery Date",
        accessor: "Delivery_date",
        //cellProps => (
        //   <React.Fragment>
        //    <b>{moment(cellProps.Delivery_date).format("DD-MM-YYYY")}</b>
        //   </React.Fragment>
        // ),
           filterable: false,
        disableFilters:true,
      },
      {
        Header: "Created By",
        accessor: "User_Name",
        //cellProps => (
        //   <React.Fragment>
        //    <b>{moment(cellProps.Delivery_date).format("DD-MM-YYYY")}</b>
        //   </React.Fragment>
        // ),
           filterable: false,
        disableFilters:true,
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            
            <div className="d-flex gap-3">
                 {cellProps.row.original.Billed === 'Y' ? (  
              <Link
                to="#"
                className="text-primary"
               
                onClick={() =>{
                  //////////////console.log(cellProps,'cell')
                
                  billrasidedit()}}>
                     
                
     
     
     <UncontrolledTooltip placement="top" target="deletetooltip2">
                 view
                </UncontrolledTooltip>
              
                {/* <i className="fa-solid fa-pen-slash"  id="edittooltip1"></i> */}
                <i className="uil uil-pen font-size-18" id="edittooltip1" />
                
              
              
              
              
                
              </Link>
                 ):
                 <Link
                 to="#"
                 className="text-primary"
                
                 onClick={() =>{
                   //////////////console.log(cellProps,'cell')
                   const po = cellProps.row.original
                   editpage(po.PO_Id)}}>
                      
                 
        <i className="uil uil-pen font-size-18" id="edittooltip1"  
        
         />
     
     <UncontrolledTooltip placement="top" target="deletetooltip2">
                  Edit
                </UncontrolledTooltip>
 
            
               
               
               
               
                 
               </Link>}
                 
              {cellProps.row.original.Billed === 'Y' ? ( 
              <Link
                to="#"
                className="text-danger"
            
                onClick={() => {
                  const po = cellProps.row.original
                  billrasid(po);
                  }}
              > 
       

                   <i
                  className="uil uil-trash-alt font-size-18"
                  id="deletetooltip2"
                />
            
               
                <UncontrolledTooltip placement="top" target="deletetooltip2">
                  Delete
                </UncontrolledTooltip>
              </Link>
                ): 
                
                <Link
                to="#"
                className="text-danger"
            
                onClick={() => {
                  const po = cellProps.row.original
                  toggledeletemodal(po.PO_Id);
                  }}
              > 
              

                   <i
                  className="uil uil-trash-alt font-size-18"
                  id="deletetooltip2"
                />
               
               
                <UncontrolledTooltip placement="top" target="deletetooltip2">
                  Delete
                </UncontrolledTooltip>
              </Link>
                }

              {/* <Link
                to="#"
                className="text-Primary"
              style={{marginTop:3}}
              onClick={() => {
                const Workorder = cellProps.row.original;
                PrintDownload(Workorder.PO_Id,Workorder.PO_No);
              }}
              >
               
                <i className="fas fa-print font-size-15"    id="deletetooltip3"></i>
                <UncontrolledTooltip placement="top" target="deletetooltip3">
                  Print
                </UncontrolledTooltip>
              </Link> */}

             



              <Link
                to="#"
                className="text-Primary"
              style={{marginTop:3}}
              onClick={() => {
             
                const po = cellProps.row.original
                viewpage(po.PO_Id)
              }}
              >
                {/* <i
                  className="uil uil-trash-alt font-size-18"
                  id="deletetooltip"
                /> */}   <i className="fas fa-print font-size-15"    id="deletetooltip6"></i>
                <UncontrolledTooltip placement="top" target="deletetooltip6">
                Print
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={()=> Deletepurchaseorder(deletid)}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="My Orders " breadcrumbItem="Purchase Order" />
          <Row style={{justifyContent:'center'}}>
          <Col lg="3">
                            <div className="mb-3" >
                              <Label htmlFor="manufacturerbrand">
                              <b> From Date </b>
                              </Label>
                  <Input type="date" value={fromdate} onChange={(e)=> Getfromdateset(e.target.value)}  />
                     
                            </div>
                          </Col>
                          <Col lg="3">
                            <div className="mb-3">
                              <Label htmlFor="manufacturerbrand">
                              <b> To Date </b>
                              </Label>
                  <Input type="date" value={todate} onChange={(e)=>GetTOdateset(e.target.value)} />
                     
                            </div>
                          </Col>
                          <Col lg="3">
                            <div className="mb-3">
                              <Label htmlFor="manufacturerbrand">
                              <b>Supplier Name </b>
                              </Label>
                              <Select
                                options={allsupplierinfo}
                     classNamePrefix="select2-search-disable"
                     defaultValue={{'label' : 'All' , 'value' : '0'}}
                     onChange={(value)=> getbuyers(value.value)}
                   />
                     
                            </div>
                          </Col>
                          <Col lg="3" style={{marginTop:"15px"}}>
                            <div className="mb-3" >
                              <Label htmlFor="manufacturerbrand">
                              <b className="text-primary">Total PO Value  </b>
                              </Label>
                    <p ><b>₹ {numeral(allpurchasenetamout).format('0,0.00')}</b></p>
                     
                            </div>
                          </Col>
          </Row>
        
          <Row>
           
            <Col xs="12">
            <Card>
                <CardBody>
              <TableContainer
                columns={columns}
                data={allpurchaseorderlists}
                isGlobalFilter={true}
                isAddOrder={true}
                isAddTableWithoutBorderStrap={true}
                handleOrderClicks={handleUserClick}
              />
             </CardBody>
             </Card>
            </Col>
          
          </Row>
      
        </div>
      </div>
      {dailoa1 ? (
      <Backdrop  open={dailoa1} className={classes.backdrop} >
      <Spinner name="ball-spin-fade-loader"  color='#fafafa' />

     </Backdrop>
      ): null}
      {Purchasesavess ? (
                    <SweetAlert
                      title="Purchase Order Added Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setPurchasesavess(false);
                      }}
                    ></SweetAlert>
                  ) : null}


{purchsedeltemessage ? (
                    <SweetAlert
                      title="Purchase Order Deleted Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setpurchsedeltemessage(false);
                      }}
                    ></SweetAlert>
                  ) : null}
      {produpdata ? (
                    <SweetAlert
                      title="Product Updated  Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setprodupdata(false);
                      }}
                    ></SweetAlert>
                  ) : null}
  {purchsebillrasied ? (
                    <SweetAlert
                      title="Purchase Bill Raised Can't Be Deleted "
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      warning
                      onConfirm={() => {
                        setpurchsebillrasied(false);
                      }}
                    ></SweetAlert>
                  ) : null}

{purchasebilledit ? (
                    <SweetAlert
                      title="Purchase Bill Raised Can't Be Edited"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      warning
                      onConfirm={() => {
                        setpurchasebilledit(false);
                      }}
                    ></SweetAlert>
                  ) : null}

{ delteprods? (
                    <SweetAlert
                      title="Purchase Order Deleted  Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setdelteprods(false);
                      }}
                    ></SweetAlert>
                  ) : null}
                    <Dialog  onClose={Closepopup1}   aria-labelledby="simple-dialog-title" open={open1}>
      <iframe src={axios.baseURL+`Getpurchaseorder`} style={{width:'500px', height:'500px'  }} ></iframe>
      {/* <object data={axios.baseURL+`Getpurchaseorder`}   style={{width:'500px', height:'500px'  }}  /> */}
      {/* <Document file={axios.baseURL+`Getpurchaseorder`} >
 
      </Document> */}
   
    </Dialog>
                  {/* <Modal isOpen={modal} toggle={toggle} size="lg" >
            <ModalHeader toggle={toggle} tag="h4">
            { "View Purchase Order"}
            </ModalHeader>
            <ModalBody>
              <Form
              
              >
              
    
             
      <div >
        <Container >
    
       
<Row>
  <Col lg={6}>
  <embed width={760} height={500}  src={axios.baseURL+`Getpurchaseorder`}></embed>
  </Col>
</Row>
        </Container>
      </div>
      
      
              </Form>
            </ModalBody>
          </Modal> */}
    </React.Fragment>
  );
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default DatatableTables;
